import { Autocomplete, TextField } from '@mui/material';
import { isEmptyString, isNotEmptyArray } from '@vy/utils';
import type { FC } from 'react';
import type { Control } from 'react-hook-form';
import { Controller, useWatch } from 'react-hook-form';
import { useNetSuiteClasses } from '../../../../../../../hooks/requests/integrations';
import type { CatalogProductsFormData } from '../../create-product-dialog-types';

type NetSuiteClassDropdownForCatalogProps = {
  control: Control<CatalogProductsFormData>;
};

export const NetSuiteClassDropdownForCatalog: FC<NetSuiteClassDropdownForCatalogProps> = ({ control }) => {
  const netSuiteClasses = useNetSuiteClasses();
  const netSuiteProduct = useWatch({ control, name: 'netSuiteProduct' });
  const hasNetSuiteProduct = isNotEmptyArray(netSuiteProduct);

  return (
    <Controller
      control={control}
      name="netSuiteClass"
      render={({ field }) => (
        <Autocomplete
          options={netSuiteClasses}
          value={field.value ?? null}
          getOptionLabel={(option) => option.name}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          disabled={!hasNetSuiteProduct}
          onChange={(_, value) => {
            field.onChange(value ?? undefined);
          }}
          data-vy="catalog-product-netsuite-class"
          renderInput={(params) => (
            <TextField
              {...params}
              label="NetSuite Class"
              placeholder="Select NetSuite class"
              size="medium"
              slotProps={{
                ...params.slotProps,
                inputLabel: { shrink: true }
              }}
              onChange={(e) => {
                if (isEmptyString(e.target.value)) {
                  field.onChange(undefined);
                }
              }}
            />
          )}
        />
      )}
    />
  );
};
